import React, { useEffect, useState, useRef } from "react";
import { useTheme } from '@material-ui/core/styles';
import styled from "styled-components";


export default function Video() {
    let api = useRef(null);
    const theme = useTheme()
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = 'https://meet.jit.si/external_api.js';
        script.async = true;
        script.onload = () => {
            const domain = 'meet.jit.si';
            const options = {
                roomName: 'StudySpotExampleApi',
                parentNode: document.querySelector('#meet'),
                userInfo: {
                    displayName: "StudySpotUser"
                },
                interfaceConfigOverwrite: {
                    SHOW_CHROME_EXTENSION_BANNER: false,
                    SHOW_PROMOTIONAL_CLOSE_PAGE: false,
                    SHOW_POWERED_BY: false,
                    AUDIO_LEVEL_PRIMARY_COLOR: theme.palette.primary.main,
                    AUDIO_LEVEL_SECONDARY_COLOR: theme.palette.primary.light,
                    DEFAULT_BACKGROUND: theme.palette.primary.dark,
                }
            };
            api.current = (new window.JitsiMeetExternalAPI(domain, options));
        };
        document.body.appendChild(script);
        setLoading(false);
        return () => {
            document.body.removeChild(script);
            if (api.current) {
                api.current.dispose();
            }
        }
    }, [theme.palette.primary.main, theme.palette.primary.light, theme.palette.primary.dark]);

    return <Fallback loading={loading} id="meet" />;

}

const Fallback = styled(props => <div {...props}>Loading</div>)`
    height: 700px;
    width: 100%;
    ${({ theme, loading }) => `
        background-color: ${theme.palette.primary.light};
        color: ${theme.palette.primary.contrastText};
        padding-top: ${loading ? "25%" : "0"};
        font-size: ${loading ? "10rem" : "0"};
    `}
    text-align: center;
`;